<template>
    <div class="error-page pt-16">
        <div class="container">
            <h1 v-html="$t('errorPage.title')"/>
            <p v-html="$t('errorPage.messages[0]')"/>
            <p v-html="$t('errorPage.messages[1]')"/>
            <p>
                {{$t('errorPage.messages[2]')}}
            </p>
            <div class="text-center">
                <button
                    @click="getBack()"
                    class="custom-btn btn-outline"
                >
                    {{$t('errorPage.btn')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'Error',
        methods: {
            getBack() {
                EventBus.$emit('getBack');
            }
        }
    };
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/components/_custom-btn.scss";
</style>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue